import React from 'react';
import { withRouter } from 'react-router-dom';

const TYPEFORM_SRC =
  'https://form.typeform.com/to/NkbG27WK?typeform-medium=embed-snippet';

class AboutMe extends React.Component {

  componentDidMount() {}

  render() {
    return (
      <div className="inf-panel" style={{ padding: 0, overflow: 'hidden' }}>
        <div style={{ padding: '24px 26px 18px' }}>
          <p className="inf-panel-title">About You</p>
          <p className="inf-panel-sub">
            Take this quick survey and stand a chance to win Amazon vouchers worth up to Rs. 1000.
          </p>
        </div>
        <iframe
          title="Influencer BFSI survey"
          src={TYPEFORM_SRC}
          width="100%"
          height="640"
          frameBorder="0"
          allow="camera; microphone; autoplay; encrypted-media;"
          style={{ border: 0, display: 'block' }}
        />
      </div>
    );
  }
}

export default withRouter(AboutMe);
